import MuiBackdrop, { BackdropProps as MuiBackdropProps } from '@mui/material/Backdrop';
import * as React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { CircularProgress } from '../CircularProgress/CircularProgress';

export type BackdropProps = MuiBackdropProps & {
  /**
   * @default 'light'
   */
  variant?: 'light' | 'dark';
};

/**
 * NOTE - must use nested with parent that has "position: relative"
 *
 * TODO - figure out how to make this 'stick' on top of peer that scrolls
 * @param props
 * @returns
 */
export const BackdropSpinner = (props: BackdropProps) => {
  const { sx, variant, ...otherProps } = props;

  return (
    <MuiBackdrop
      {...otherProps}
      sx={[
        (theme) => ({
          position: 'absolute',
          backgroundColor: variant === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)',
          zIndex: theme.zIndex.drawer + 1
        }),
        ...toSxArray(sx)
      ]}>
      <CircularProgress color={variant === 'dark' ? 'primaryInverted' : 'primary'} />
    </MuiBackdrop>
  );
};
